/**
 * Created by Sale on 9/5/2024
 */
import store from "./store";
import router from "./router";

export default {
    store,
    router
};